export class Alert{
    title: Nullable<string>;
    message: Nullable<string>;
    hidden: boolean;

    constructor() {
        this.hidden = true;
        this.title = null;
        this.message = null;
    }

    show(title: string, message: string): void {
        this.title = title;
        this.message = message;
        this.hidden = false;
    }

    hide(): void {
        this.hidden = true;
        this.title = null;
        this.message = null;
    }
}